import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";

interface WatchTripSuccessFooterProps {
  cn: (elementName: string) => string;
  onClose: () => void;
}

export const WatchTripSuccessFooter = ({
  cn,
  onClose,
}: WatchTripSuccessFooterProps): JSX.Element => {
  const { t } = useI18nContext();

  return (
    <button
      className={clsx(cn("cta-button"), "cta-button")}
      type="button"
      onClick={onClose}
    >
      {t("done")}
    </button>
  );
};
